import axios from "axios";
import { Folder } from "../interfaces/folder";

export function getFolders(parent_id: number | null = null, user_id: number | null = null) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder';

    const params: string[] = [];

    // Always send parent_id parameter, even when null
    if (parent_id !== null) {
        params.push('parent_id=' + parent_id);
    } else {
        params.push('parent_id=null');
    }

    // Add user_id for admin viewing other user's folders
    if (user_id !== null) {
        params.push('user_id=' + user_id);
    }

    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }

    return axios.get(endpointUrl, { headers: headers });
}

export function getFolder(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder/' + id;
    return axios.get(endpointUrl, { headers: headers });
}

export function createFolder(body_obj: { name: string, description?: string, parent_id?: number | null }) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateFolder(body_obj: { id: number, name?: string, description?: string | null, parent_id?: number | null }) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteFolder(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

export function shareFolder(id: number, body_obj: {
    share_type: string,
    share_target_id: number,
    share_role?: string | null,
    permission: string
}) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder/' + id + '/share';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function unshareFolder(id: number, share_id?: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder/' + id + '/unshare';
    const body_obj = share_id ? { share_id: share_id } : {};
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function getFolderPath(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder/' + id + '/path';
    return axios.get(endpointUrl, { headers: headers });
}

export function bulkMoveFolder(folder_ids: number[], parent_id: number | null) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder/bulk-move';
    const body_obj = {
        folder_ids: folder_ids,
        parent_id: parent_id
    };
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function bulkDeleteFolder(folder_ids: number[]) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder/bulk-delete';
    const body_obj = {
        folder_ids: folder_ids
    };
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function downloadFolder(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/folder/' + id + '/download';
    return axios.get(endpointUrl, { headers: headers });
}

/**
 * Download a folder as ZIP (for protected documents)
 */
export async function downloadFolderAsBlob(id: number, folderName: string): Promise<void> {
    const token = localStorage.getItem('token');
    const endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/document/bulk-download';

    const response = await axios.post(endpointUrl, {
        document_ids: [],
        folder_ids: [id]
    }, {
        headers: {
            'Authorization': 'Bearer ' + token
        },
        responseType: 'blob'
    });

    const url = window.URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = folderName + '.zip';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}
